export default "__VITE_ASSET__ZEbOyFws__"